/**
 * WithdrawalOrderSelect Component
 *
 * Dropdown selector for retirement withdrawal order strategy.
 * Used in Assumptions form to set account withdrawal priority.
 */

import React from "react";
import type { WithdrawalOrder } from "../types/settings";
import { WITHDRAWAL_ORDER_OPTIONS } from "../types/settings";

/** Human-readable labels for each withdrawal strategy */
const WITHDRAWAL_ORDER_LABELS: Record<WithdrawalOrder, string> = {
  standard: "Standard",
  "tfsa-last": "TFSA Last",
  "rrsp-first": "RRSP First",
  "pro-rata": "Pro-Rata",
  "tax-optimal": "Tax Optimal",
};

export interface WithdrawalOrderSelectProps {
  /** Currently selected withdrawal order (empty string for no selection) */
  value: string;
  /** Callback with the selected withdrawal order */
  onChange: (value: string) => void;
  /** Optional additional class names */
  className?: string;
}

/**
 * WithdrawalOrderSelect — retirement withdrawal strategy dropdown
 *
 * Renders a labeled select element with all five withdrawal strategies.
 * Includes a placeholder option.
 */
export const WithdrawalOrderSelect: React.FC<WithdrawalOrderSelectProps> = ({
  value,
  onChange,
  className,
}) => {
  return (
    <div className={className}>
      <label
        htmlFor="withdrawal-order-select"
        className="withdrawal-order-select-label"
      >
        Withdrawal Order
      </label>
      <select
        id="withdrawal-order-select"
        className="withdrawal-order-select"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">Select strategy...</option>
        {WITHDRAWAL_ORDER_OPTIONS.map((option) => (
          <option key={option} value={option}>
            {WITHDRAWAL_ORDER_LABELS[option]}
          </option>
        ))}
      </select>
    </div>
  );
};

export default WithdrawalOrderSelect;
